import fetch from "auth/FetchInterceptor";

const meetingService = {};

meetingService.getAll = function () {
	return fetch({
		url: "/v1/rest/meeting",
		method: "get",
	});
};

meetingService.getById = function (id) {
	return fetch({
		url: `/v1/rest/meeting/${id}`,
		method: "get",
	});
};

meetingService.post = function (data) {
	return fetch({
		url: "/v1/rest/meeting",
		method: "post",
		data: data,
	});
};

meetingService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/meeting/${id}`,
		method: "put",
		data: data,
	});
};

meetingService.delete = function (id, scope) {
	if (scope) {
		return fetch({
			url: `/v1/rest/meeting/${id}?scope=${scope}`,
			method: "delete",
		});
	}

	return fetch({
		url: `/v1/rest/meeting/${id}`,
		method: "delete",
	});
};

export default meetingService;
